import React, {
    useEffect,
} from "react";
import {useDispatch, useSelector} from 'react-redux';

import {
    Select,
    List,
    Button,
    Grid,
    Skeleton
} from 'antd';

import * as T from 'utils/types';
import TotalResult from "components/panel/TotalResult";
import { gsPubTabThunks } from "./GsPubTabSlice";
import Error500 from "components/errors/Error500";
import GsPublicationTitle from "components/gsPublication/GsPublicationTitle";
import GsPublicationDescription from "components/gsPublication/GsPublicationDescription";
import "../PubTab/AltmetricBadge.css"
import searchPgUserInputsS from 'features/content/search_page/UserInputsSlice';

const {Option} = Select;

// google scholar publication tab
export default () => {
    const dispatch = useDispatch();


    useEffect(() => {
        // _altmetric_embed_init is offered by Altmetric in embeded.js file
        // this func will let js to find new altmetric-embed div and fetch the data for them
        // eslint-disable-next-line
        eval('if(typeof _altmetric_embed_init!="undefined"){_altmetric_embed_init();}');
    })

    const {
        searchInput,
        keywordType,
        facultyID,
        departmentID,
        searchTab,
        gsPubSpecific: { year, sortType }
    } = useSelector((state: T.RootState) => state.searchPgUserInputs);

    // below section is been commented because we decide to never sort the pubs acoording to rank (relevance)
    // we only sort based on either date or Altmetric score

    // // we do this because '-rank' can only be used when search using keywords
    // useEffect(()=>{
    //     if(sortType!=="-altmetric_score"){
    //         if(keywordType==="match" ){ // means search using name
    //             sortType!=="-date" && dispatch(searchPgUserInputsS.actions.setSortType("-date"));
    //         }
            
    //         if(keywordType==="search"){ // means search using keywords
    //             if(searchInput===''){ // if searchInput is empty, sort the pub using date
    //                 sortType!=="-date" && dispatch(searchPgUserInputsS.actions.setSortType("-date"));
    //             }else{ // if searchInput is not empty, sort the pub using rank
    //                 sortType!=="-rank" && dispatch(searchPgUserInputsS.actions.setSortType("-rank"));
    //             }
    //         }
    //     }
    // }, [dispatch, searchInput, keywordType, sortType]);

    const {
        total,
        status,
        hasNext,
        gsPubList,
        yearFilter:{ years, total:total_yearFilter, status: status_yearFilter}
    } = useSelector((state: T.RootState) => state.gsPubTab);



    useEffect(()=>{
        searchTab === T.SearchTab.GS_PUBLICATIONS && dispatch(gsPubTabThunks.initList({
            keywordType, searchInput,
            facultyID, departmentID,
            year, sortType
        }));
    }, [
        keywordType, searchInput,
        facultyID, departmentID,
        year, sortType, 
        dispatch, searchTab,
    ]);

    useEffect(()=>{
        dispatch(gsPubTabThunks.rGsPubYearStat({
            keywordType, searchInput,
            facultyID, departmentID,
        }));
    }, [
        keywordType, searchInput,
        facultyID, departmentID, dispatch
    ]);

    const screens = Grid.useBreakpoint();
    const breakpoint = screens.xs;

    console.log('haha')
    console.log(years.filter(x=>x.year===year).length===0)
    console.log(years)

    return <>
        {total>=0&&status==="succeeded"&&<TotalResult searchResult={total}/>}




        {total_yearFilter>=0&&<Select
            className="sub-heading-font"
            value={year}
            style={{ width: 200, marginBottom: 4 }}
            onChange={ value => {
                dispatch(searchPgUserInputsS.actions.setGsPubYear(value));
            }}
            loading={status_yearFilter!=="succeeded"}
            disabled={status_yearFilter!=="succeeded"}
            filterOption={(input, option) => (option !== undefined) && 
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        >
            {[
                <Option className="sub-heading-font" value={-1} key={-1}>
                    {`All years (${total_yearFilter})`}
                </Option>,
                ...(years.map( x => 
                <Option className="sub-heading-font" value={x.year} key={x.year}>
                    {`${x.year} (${x.cnt})`}
                </Option>))
            ].concat(
                (year!==-1&&years.filter(x=>x.year===year).length===0)?[
                  <Option className="sub-heading-font" value={year} key={year}>
                  {`${year} (0)`}
                  </Option>
                ]:[]
            )}
        </Select>}

        {breakpoint && <br />}

        {/* 
            below section is been commented out because we decide to never sort the pubs acoording to rank (relevance)
            we only sort based on either date or Altmetric score 
        */}

        {/* {(searchInput===''||keywordType==="match")&&<Button
            type="text"
            style={{ fontSize: '13px', color: '#888' }}
            onClick={ () => {
                if (sortType !== '-date') {
                    dispatch(
                        searchPgUserInputsS.actions.setSortType('-date')
                    );
                }
            }}>
            Sort by date {sortType === '-date' && '\u2193'}
        </Button>}
        {searchInput!==''&&keywordType==="search"&&<Button
            type="text"
            style={{ fontSize: '13px', color: '#888' }}
            onClick={ () => {
                if (sortType !== '-rank') {
                    dispatch(
                        searchPgUserInputsS.actions.setSortType('-rank')
                    );
                }
            }}>
            Sort by relevance {sortType === '-rank' && '\u2193'}
        </Button>} */}

        <Button
            className="sub-heading-font"
            type="text"
            style={{ fontSize: '13px', color: '#888', marginBottom: 4 }}
            onClick={ () => {
                if (sortType !== '-year' && sortType!=='year') {
                    dispatch(
                        searchPgUserInputsS.actions.setGsPubSortType('-year')
                    );
                }else{
                    dispatch(
                        searchPgUserInputsS.actions.setGsPubSortType(
                            sortType==='year'?'-year':'year'
                        )
                    );
                }
            }}>
            Sort by year {
              (sortType === 'year' && '\u2191') || (sortType === '-year' && '\u2193')
            }
        </Button>
        <Button
            className="sub-heading-font"
            type="text"
            style={{ fontSize: '13px', color: '#888', marginBottom: 4 }}
            onClick={ () => {
                if (sortType !== '-citationCount' && sortType !== 'citationCount') {
                    dispatch(
                        searchPgUserInputsS.actions.setGsPubSortType('-citationCount')
                    );
                }else{
                    dispatch(
                        searchPgUserInputsS.actions.setGsPubSortType(
                            sortType==='citationCount'?'-citationCount':'citationCount'
                        )
                    );
                }
            }}>
            Sort by citation count {
              (sortType === 'citationCount' && '\u2191') || (sortType==='-citationCount' && '\u2193')
            }
        </Button>
        {/* <Button
            className="sub-heading-font"
            type="text"
            style={{ fontSize: '13px', color: '#888', marginBottom: 4 }}
            onClick={ () => {
                if (sortType !== '-altmetric_score') {
                    dispatch(
                        searchPgUserInputsS.actions.setSortType('-altmetric_score')
                    );
                }
            }}>
            Sort by Altmetric score {sortType === '-altmetric_score' && '\u2193'}
        </Button> */}







        {status!=="failed"&&<List
            loading={status==="idle"}
            itemLayout="horizontal"
            loadMore={
                hasNext ? <div
                    style={{
                        textAlign: 'center',
                        marginTop: 12,
                        height: 32,
                        lineHeight: '32px',
                    }}
                >
                    <Button
                        className="sub-heading-font"
                        onClick={() => dispatch(gsPubTabThunks.loadMore())}
                    >
                        More
                    </Button>
                </div> : null
            }
            dataSource={gsPubList}
            renderItem={ item => {
                const pub = item.item as T.GsPublication;
                return <List.Item>
                    <Skeleton avatar title={false} loading={item.loading} active>
                        <List.Item.Meta

                            avatar={<div
                                    className='altmetric-embed'
                                    data-badge-type='donut'
                                    data-badge-popover="right"
                                    data-link-target='_blank'
                                    data-doi={pub?.doi||"0"}
                                ></div>}

                            title={ <GsPublicationTitle gsPub={pub}/> }

                            description={ <GsPublicationDescription gsPub={pub}/> }

                        />
                    </Skeleton>
                </List.Item>;
            } }
        />}
        
        { status==="failed"&&<Error500/> }




    </>;
}